import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=6bb06625&scoped=true"
import script from "./Lead.vue?vue&type=script&lang=ts"
export * from "./Lead.vue?vue&type=script&lang=ts"
import style0 from "./Lead.vue?vue&type=style&index=0&id=6bb06625&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb06625",
  null
  
)

export default component.exports